// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/tls_service.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { File, FileJson } from "./file_pb";
import { file_mochabugapis_adapt_plugins_v1_file } from "./file_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/tls_service.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_tls_service: GenFile = /*@__PURE__*/
  fileDesc("Ci9tb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS90bHNfc2VydmljZS5wcm90bxIdbW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEi6wEKDVRsc0RlZmluaXRpb24SSwoEbW9kZRgBIAEoDjIxLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLlRsc0RlZmluaXRpb24uTW9kZUIKukgHggEEEAEgABI+CgdkZWZhdWx0GAIgASgLMigubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuVGxzQ29uZmlnSACIAQEiQQoETW9kZRIUChBNT0RFX1VOU1BFQ0lGSUVEEAASDQoJTU9ERV9NVExTEAESFAoQTU9ERV9TRVJWRVJfT05MWRACQgoKCF9kZWZhdWx0IvkBCglUbHNDb25maWcSPgoJY2FfYnVuZGxlGAEgASgLMiMubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuRmlsZUIGukgDyAEBEkUKC2NlcnRpZmljYXRlGAIgASgLMiMubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuRmlsZUIGukgDyAEBSACIAQESRQoLcHJpdmF0ZV9rZXkYAyABKAsyIy5tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MS5GaWxlQga6SAPIAQFIAYgBAUIOCgxfY2VydGlmaWNhdGVCDgoMX3ByaXZhdGVfa2V5YgZwcm90bzM", [file_buf_validate_validate, file_mochabugapis_adapt_plugins_v1_file]);

/**
 * TlsConfig configures the TLS behavior for the connection.
 * It supports two modes:
 * 1. MTLS: True Mutual TLS where both the client and server present and validate each other's certificates.
 * 2. SERVER_ONLY: Server-only validation where only the server presents a certificate, and the client validates it.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.TlsDefinition
 */
export type TlsDefinition = Message<"mochabugapis.adapt.plugins.v1.TlsDefinition"> & {
  /**
   * Select the TLS mode for the connection.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.TlsDefinition.Mode mode = 1;
   */
  mode: TlsDefinition_Mode;

  /**
   * The optional default value
   *
   * @generated from field: optional mochabugapis.adapt.plugins.v1.TlsConfig default = 2;
   */
  default?: TlsConfig;
};

/**
 * TlsConfig configures the TLS behavior for the connection.
 * It supports two modes:
 * 1. MTLS: True Mutual TLS where both the client and server present and validate each other's certificates.
 * 2. SERVER_ONLY: Server-only validation where only the server presents a certificate, and the client validates it.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.TlsDefinition
 */
export type TlsDefinitionJson = {
  /**
   * Select the TLS mode for the connection.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.TlsDefinition.Mode mode = 1;
   */
  mode?: TlsDefinition_ModeJson;

  /**
   * The optional default value
   *
   * @generated from field: optional mochabugapis.adapt.plugins.v1.TlsConfig default = 2;
   */
  default?: TlsConfigJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.TlsDefinition.
 * Use `create(TlsDefinitionSchema)` to create a new message.
 */
export const TlsDefinitionSchema: GenMessage<TlsDefinition, TlsDefinitionJson> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_tls_service, 0);

/**
 * Mode specifies which TLS configuration to use.
 *
 * @generated from enum mochabugapis.adapt.plugins.v1.TlsDefinition.Mode
 */
export enum TlsDefinition_Mode {
  /**
   * Default value. Invalid.
   *
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * MTLS requires both the client and server to present valid certificates.
   *
   * @generated from enum value: MODE_MTLS = 1;
   */
  MTLS = 1,

  /**
   * SERVER_ONLY requires only the server to present a certificate, and the client performs validation.
   *
   * @generated from enum value: MODE_SERVER_ONLY = 2;
   */
  SERVER_ONLY = 2,
}

/**
 * Mode specifies which TLS configuration to use.
 *
 * @generated from enum mochabugapis.adapt.plugins.v1.TlsDefinition.Mode
 */
export type TlsDefinition_ModeJson = "MODE_UNSPECIFIED" | "MODE_MTLS" | "MODE_SERVER_ONLY";

/**
 * Describes the enum mochabugapis.adapt.plugins.v1.TlsDefinition.Mode.
 */
export const TlsDefinition_ModeSchema: GenEnum<TlsDefinition_Mode, TlsDefinition_ModeJson> = /*@__PURE__*/
  enumDesc(file_mochabugapis_adapt_plugins_v1_tls_service, 0, 0);

/**
 * The actual TLS configuration
 *
 * @generated from message mochabugapis.adapt.plugins.v1.TlsConfig
 */
export type TlsConfig = Message<"mochabugapis.adapt.plugins.v1.TlsConfig"> & {
  /**
   * The ca bundle in PEM format
   * The content of the file must be PEM format after decoding
   * If a certificate chain is presented. The server certificate must be the first one
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.File ca_bundle = 1;
   */
  caBundle?: File;

  /**
   * The certificate in PEM format
   * The content of the file must be PEM format after decoding
   * If a certificate chain is presented. The server certificate must be the first one
   *
   * @generated from field: optional mochabugapis.adapt.plugins.v1.File certificate = 2;
   */
  certificate?: File;

  /**
   * The private key in PEM format
   * The content of the file must be PEM format after decoding
   * The content must contain a PRIVATE KEY block
   *
   * @generated from field: optional mochabugapis.adapt.plugins.v1.File private_key = 3;
   */
  privateKey?: File;
};

/**
 * The actual TLS configuration
 *
 * @generated from message mochabugapis.adapt.plugins.v1.TlsConfig
 */
export type TlsConfigJson = {
  /**
   * The ca bundle in PEM format
   * The content of the file must be PEM format after decoding
   * If a certificate chain is presented. The server certificate must be the first one
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.File ca_bundle = 1;
   */
  caBundle?: FileJson;

  /**
   * The certificate in PEM format
   * The content of the file must be PEM format after decoding
   * If a certificate chain is presented. The server certificate must be the first one
   *
   * @generated from field: optional mochabugapis.adapt.plugins.v1.File certificate = 2;
   */
  certificate?: FileJson;

  /**
   * The private key in PEM format
   * The content of the file must be PEM format after decoding
   * The content must contain a PRIVATE KEY block
   *
   * @generated from field: optional mochabugapis.adapt.plugins.v1.File private_key = 3;
   */
  privateKey?: FileJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.TlsConfig.
 * Use `create(TlsConfigSchema)` to create a new message.
 */
export const TlsConfigSchema: GenMessage<TlsConfig, TlsConfigJson> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_tls_service, 1);

